<template>
    <div>
        <oc-plugin-slot name="before-content" v-bind="col" ref="beforeContent" />

        <oc-button size="small" type="info" title="Add row" text="+" class="oc-table-plus-btn" @click="$source.addRow(index)" />
        <oc-button size="small" type="info" title="Remove row" text="-" class="oc-table-minus-btn" @click="$source.removeRow(index)" />

        <oc-plugin-slot name="after-content" v-bind="col" ref="afterContent" />
    </div>
</template>

<script>
export default {
    name: 'oc-plus-minus-row-cell',
    inject: ['$source'],
    props: ['row', 'col', 'index', 'options']
}
</script>

<style scoped>
    .oc-table-plus-btn, .oc-table-minus-btn {min-width: 30px;}
</style>
